import { ContractorGroupData } from "../../../ContractorGroup/ContractorGroupData";
import { LocalData } from "../../LocalData";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { t } from "i18next";
import { FirebaseDataPropertyField } from "../../DataObjectField/CustomFields/FirebaseDataPropertyField";
import { FirebaseDataBooleanField } from "../../DataObjectField/Generic/FirebaseDataBooleanField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";

export class ContractorGroupDataHelper extends DataObjectHelper<ContractorGroupData> {
  id = () => "contractor";

  displayName = () => t("main.contractorGroups");

  name = new FirebaseDataStringField<ContractorGroupData>("name", t("main.name"), (group) => group.name, "title");
  properties = new FirebaseDataPropertyField<ContractorGroupData>(
    "properties",
    t("main.properties"),
    (group) => group.properties.filter((p) => p.members.hasData(LocalData.currentUser.id)),
    "business",
    true
  );
  contactEmail = new FirebaseDataStringField<ContractorGroupData>("contactEmail", t("main.emailAdress"), (group) => group.contactEmail, "email");
  contactPhone = new FirebaseDataStringField<ContractorGroupData>("contactPhone", t("main.phoneNumber"), (group) => group.contactPhone, "phone");
  receivesNotifications = new FirebaseDataBooleanField<ContractorGroupData>(
    "receivesNotifications",
    t("main.sendNotificationsToContactEmail"),
    (group) => group.receivesNotifications,
    "notifications"
  );

  override getAllDatas(): ContractorGroupData[] {
    const contractors: ContractorGroupData[] = [];
    for (const p of LocalData.currentUser.properties) {
      for (const c of p.contractors) {
        if (!contractors.includes(c)) {
          contractors.push(c);
        }
      }
    }
    return contractors;
  }

  loadAll(): Promise<any> {
    const contractors: ContractorGroupData[] = [];

    for (const property of LocalData.currentUser.properties) {
      for (const contractor of property.contractors) {
        if (!contractors.includes(contractor)) {
          contractors.push(contractor);
        }
      }
    }
    return Promise.all(contractors.map((c) => c.load()));
  }

  allFields() {
    return [this.name, this.properties, this.contactEmail, this.contactPhone, this.receivesNotifications];
  }

  getAllDataTableDatas(documents: ContractorGroupData[]): DataTableData[] {
    return documents.map((contractor) => {
      const properties = contractor.properties.filter((p) => p.members.hasData(LocalData.currentUser.id));
      return {
        key: contractor.id,
        cells: {
          name: contractor.name,
          phone: contractor.contactPhone,
          email: contractor.contactEmail,
          properties: properties.length < 3 ? properties.map((p) => p.name).join(", ") : properties.length + " " + t("main.pcs"),
        },
      };
    });
  }
  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      { key: "name", title: t("main.name") },
      { key: "phone", title: t("main.phoneNumber") },
      { key: "email", title: t("main.email") },
      { key: "properties", title: t("main.properties") },
    ];
  }

  override saveUpdate(data: ContractorGroupData, updatedRawData: { [key: string]: any }): Promise<any> {
    return data.saveUpdate(updatedRawData);
  }
}

